<template>
  <vs-card class="shadow">
    <vs-row class="md:p-5">
      <vs-col vs-w="12" class="pl-5">
        <div class="flex flex-col w-4/5">
          <div class="caption">
            <div class="flex flex-col">
              <h5 class="font-bold text-sm">Username:</h5>
              <h5 class="font-normal mr-2 w-max">
                {{ report.usernameSocmed }}
              </h5>
            </div>
          </div>
          <div class="caption mt-5">
            <div class="flex flex-col">
              <h5 class="font-bold text-sm">URL Konten:</h5>
              <a v-if="report.urlContent" :href="report.urlContent">{{
                report.urlContent
              }}</a>
              <p v-else :href="report.urlContent">-</p>
            </div>
          </div>
        </div>
        <vs-divider />
        <div class="flex flex-col" v-if="platform !== 'gdrive'">
          <div class="w-full">
            <h6>Report</h6>
            <div class="flex justify-around py-5">
              <div
                v-if="platform === 'twitter'"
                class="flex flex-col items-center"
              >
                <vs-icon
                  icon="repeat"
                  size="large"
                  style="rotate: 90deg"
                ></vs-icon>
                <p class="font-bold text-base">{{ report.retweet || 0 }}</p>
                <p>Retweet</p>
              </div>
              <div
                v-if="platform === 'twitter' || platform === 'shopee'"
                class="flex flex-col items-center"
              >
                <vs-icon icon="bar_chart" size="large"></vs-icon>
                <p class="font-bold text-base">{{ report.view || 0 }}</p>
                <p>View</p>
              </div>
              <div
                v-if="platform === 'lemon8' || platform === 'threads'"
                class="flex flex-col items-center"
              >
                <vs-icon icon="bookmark" size="large"></vs-icon>
                <p class="font-bold text-base">{{ report.saving || 0 }}</p>
                <p>Save</p>
              </div>
              <div
                v-if="platform === 'facebook'"
                class="flex flex-col items-center"
              >
                <vs-icon icon="emoji_emotions" size="large"></vs-icon>
                <p class="font-bold text-base">{{ report.reaction || 0 }}</p>
                <p>Reactions</p>
              </div>
              <div
                v-if="platform === 'facebook' || platform === 'youtube'"
                class="flex flex-col items-center"
              >
                <vs-icon icon="groups" size="large"></vs-icon>
                <p class="font-bold text-base">{{ report.follower || 0 }}</p>
                <p v-if="platform === 'youtube'">Subscribers</p>
                <p v-else>Reach</p>
              </div>
              <div
                v-if="platform === 'tiktok'"
                class="flex flex-col items-center"
              >
                <vs-icon icon="visibility" size="large"></vs-icon>
                <p class="font-bold text-base">{{ report.view || 0 }}</p>
                <p>Views</p>
              </div>
              <div
                v-if="platform === 'instagram'"
                class="flex flex-col items-center"
              >
                <vs-icon icon="person" size="large"></vs-icon>
                <p class="font-bold text-base">{{ report.follower || 0 }}</p>
                <p>Followers</p>
              </div>
              <div
                v-if="platform === 'shopee'"
                class="flex flex-col items-center"
              >
                <vs-icon icon="person" size="large"></vs-icon>
                <p class="font-bold text-base">
                  {{
                    report.user_social_media
                      ? report.user_social_media.follower
                      : 0
                  }}
                </p>
                <p>Followers</p>
              </div>
              <div
                v-if="
                  platform === 'instagram' ||
                  platform === 'tiktok' ||
                  platform === 'youtube' ||
                  platform === 'twitter' ||
                  platform === 'lemon8' ||
                  platform === 'threads' ||
                  platform === 'shopee'
                "
                class="flex flex-col items-center"
              >
                <vs-icon icon="thumb_up" size="large"></vs-icon>
                <p class="font-bold text-base">{{ report.like || 0 }}</p>
                <p>Likes</p>
              </div>
              <div
                v-if="platform === 'youtube'"
                class="flex flex-col items-center"
              >
                <vs-icon icon="thumb_down" size="large"></vs-icon>
                <p class="font-bold text-base">{{ report.dislike || 0 }}</p>
                <p>Dislikes</p>
              </div>
              <div
                v-if="
                  platform === 'facebook' ||
                  platform === 'tiktok' ||
                  platform === 'twitter' ||
                  platform === 'lemon8' ||
                  platform === 'threads' ||
                  platform === 'shopee'
                "
                class="flex flex-col items-center"
              >
                <vs-icon icon="share" size="large"></vs-icon>
                <p class="font-bold text-base">{{ report.share || 0 }}</p>
                <p>Share</p>
              </div>
              <div class="flex flex-col items-center">
                <vs-icon icon="comment" size="large"></vs-icon>
                <p class="font-bold text-base">{{ report.comment || 0 }}</p>
                <p>Comments</p>
              </div>
              <div
                v-if="platform === 'facebook' || platform === 'instagram'"
                class="flex flex-col items-center"
              >
                <vs-icon icon="image" size="large"></vs-icon>
                <p class="font-bold text-base">{{ report.postOrVideo || 0 }}</p>
                <p>Post</p>
              </div>
              <div
                v-if="platform === 'tiktok' || platform === 'youtube'"
                class="flex flex-col items-center"
              >
                <vs-icon icon="videocam" size="large"></vs-icon>
                <p class="font-bold text-base">{{ report.postOrVideo || 0 }}</p>
                <p>Video</p>
              </div>
              <div
                v-if="platform === 'instagram'"
                class="flex flex-col items-center"
              >
                <vs-icon icon="visibility" size="large"></vs-icon>
                <p class="font-bold text-base">{{ report.viewVideo || 0 }}</p>
                <p>View</p>
              </div>
            </div>
          </div>
          <vs-divider />
          <div v-if="platform !== 'lemon8' && platform !== 'threads'">
            <h6 class="font-normal">
              Engagement rate:
              <span class="font-semibold text-lg"
                >{{
                  report.engagementresult
                    ? report.engagementresult.toFixed(2)
                    : 0
                }}%</span
              >
            </h6>
          </div>
        </div>
      </vs-col>
    </vs-row>
  </vs-card>
</template>

<script>
import moment from "moment";
export default {
  props: {
    report: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      moment,
    };
  },
  computed: {
    platform() {
      return this.report.platformText.toLowerCase();
    },
  },
};
</script>

<style></style>
